module.exports = __webpack_public_path__ + "img/m5.798e140e.png";